import { tuple2, object, seq as seq_4 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { empty, singleton, append, delay, toList, map } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { ForageCrop, FarmCrop, CropAmount, SeedPrice, Date$, SeasonsModule_ofSeq, CropAmountModule_singleAmount, SeasonsModule_contains, SeasonModule_name } from "./Crops.js";
import { array_type, tryParseEnum, obj_type, enum_type, int32_type, getEnumValues } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { defaultOf, structuralHash, uncurry3, uncurry2, compare, equals } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { defaultArg, value as value_8 } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { ProcessedItem_$reflection, Item_$reflection } from "./Items.js";
import { FSharpRef, toString } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { tryParse } from "../fable_modules/fable-library-js.4.29.0/Int32.js";
import { tuple2 as tuple2_1, bool, optional, field as field_1, map3, fail, float, string, object as object_1, succeed, andThen, keyValuePairs, array as array_1, map as map_1, uint32 } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { tail, head, isEmpty } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { ErrorReason } from "../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.29.0/Result.js";
import { Table$2, Table_addAll } from "./Prelude.js";
import { Dictionary } from "../fable_modules/fable-library-js.4.29.0/MutableMap.js";
import { Fertilizer } from "./Skills.js";
import { Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { SupplementalData, ExtractedData } from "./Game.js";

export function Encode_mapSeq(encoder, seq) {
    return seq_4(map(encoder, seq));
}

export function Encode_keyValues(keyString, encodeValue, seq) {
    return object(map((tupledArg) => [keyString(tupledArg[0]), encodeValue(tupledArg[1])], seq));
}

export function Encode_table(keyString, encodeValue, table) {
    return Encode_keyValues(keyString, encodeValue, table.fields[0]);
}

export function Encode_seedId(seed) {
    return seed;
}

export function Encode_itemId(item) {
    return item;
}

export function Encode_season(season) {
    return SeasonModule_name(season);
}

export function Encode_seasons(seasons) {
    let array;
    return Encode_mapSeq(Encode_season, (array = getEnumValues(enum_type("StardewValleyStonks.Season", int32_type, [["Spring", 0], ["Summer", 1], ["Fall", 2], ["Winter", 3]])), array.filter((season) => SeasonsModule_contains(season, seasons))));
}

export function Encode_date(date) {
    return object([["Season", Encode_season(date.Season)], ["Day", date.Day]]);
}

export function Encode_fertilizer(fertilizer) {
    return object(toList(delay(() => append(singleton(["Name", fertilizer.Name]), delay(() => append((fertilizer.Quality !== 0) ? singleton(["Quality", fertilizer.Quality]) : empty(), delay(() => ((fertilizer.Speed !== 0) ? singleton(["Speed", fertilizer.Speed]) : empty()))))))));
}

export function Encode_seedPrice(_arg) {
    if (_arg.tag === 1) {
        if (_arg.fields[1] != null) {
            const p_1 = _arg.fields[1];
            return object([["Type", "Scaling"], ["Vendor", _arg.fields[0]], ["Price", p_1]]);
        }
        else {
            return object([["Type", "Scaling"], ["Vendor", _arg.fields[0]]]);
        }
    }
    else {
        return object([["Type", "Fixed"], ["Vendor", _arg.fields[0]], ["Price", _arg.fields[1]]]);
    }
}

export function Encode_cropAmount(amount) {
    return object(toList(delay(() => append((amount.MinCropYield !== CropAmountModule_singleAmount.MinCropYield) ? singleton(["MinCropYield", amount.MinCropYield]) : empty(), delay(() => append((amount.MaxCropYield !== CropAmountModule_singleAmount.MaxCropYield) ? singleton(["MaxCropYield", amount.MaxCropYield]) : empty(), delay(() => append((amount.ExtraCropChance !== CropAmountModule_singleAmount.ExtraCropChance) ? singleton(["ExtraCropChance", amount.ExtraCropChance]) : empty(), delay(() => append((amount.CanDouble !== CropAmountModule_singleAmount.CanDouble) ? singleton(["CanDouble", amount.CanDouble]) : empty(), delay(() => append((amount.FarmLevelsPerYieldIncrease !== CropAmountModule_singleAmount.FarmLevelsPerYieldIncrease) ? singleton(["FarmLevelsPerYieldIncrease", amount.FarmLevelsPerYieldIncrease]) : empty(), delay(() => ((amount.FarmingQualities !== CropAmountModule_singleAmount.FarmingQualities) ? singleton(["FarmingQualities", amount.FarmingQualities]) : empty()))))))))))))));
}

export function Encode_farmCrop(crop) {
    return object(toList(delay(() => append(singleton(["Seed", Encode_seedId(crop.Seed)]), delay(() => append(singleton(["Item", Encode_itemId(crop.Item)]), delay(() => append(!equals(crop.Amount, CropAmountModule_singleAmount) ? singleton(["Amount", Encode_cropAmount(crop.Amount)]) : empty(), delay(() => {
        let tupledArg;
        return append((crop.ExtraItem != null) ? singleton(["ExtraItem", (tupledArg = value_8(crop.ExtraItem), tuple2(Encode_itemId, (value) => value, tupledArg[0], tupledArg[1]))]) : empty(), delay(() => append(crop.Giant ? singleton(["Giant", crop.Giant]) : empty(), delay(() => append(singleton(["Seasons", Encode_seasons(crop.Seasons)]), delay(() => append(singleton(["Stages", Encode_mapSeq((value_3) => value_3, crop.Stages)]), delay(() => append((crop.RegrowTime != null) ? singleton(["RegrowTime", value_8(crop.RegrowTime)]) : empty(), delay(() => (crop.Paddy ? singleton(["Paddy", crop.Paddy]) : empty())))))))))));
    })))))))));
}

export function Encode_forageCrop(crop) {
    return object([["Seed", Encode_seedId(crop.Seed)], ["Foragables", Encode_mapSeq(Encode_itemId, crop.Foragables)], ["SeedRecipeUnlockLevel", crop.SeedRecipeUnlockLevel], ["Season", Encode_season(crop.Season)], ["Stages", Encode_mapSeq((value_1) => value_1, crop.Stages)]]);
}

export function Encode_extractedData(data) {
    let encoder_1;
    return object([["Items", Encode_mapSeq(Auto_generateBoxedEncoder_437914C6(Item_$reflection(), undefined, undefined, undefined), data.Items)], ["Products", Encode_table(toString, (encoder_1 = Auto_generateBoxedEncoder_437914C6(obj_type, undefined, undefined, undefined), (seq_1) => Encode_mapSeq(encoder_1, seq_1)), data.Products)], ["FarmCrops", Encode_mapSeq(Encode_farmCrop, data.FarmCrops)], ["ForageCrops", Encode_mapSeq(Encode_forageCrop, data.ForageCrops)]]);
}

export const Decode_parseItemId = (str) => {
    let matchValue, outArg;
    return (matchValue = ((outArg = 0, [tryParse(str, 511, true, 32, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg])), matchValue[0] ? (matchValue[1] * 1) : undefined);
};

export const Decode_parseSeedId = (str) => {
    let matchValue, outArg;
    return (matchValue = ((outArg = 0, [tryParse(str, 511, true, 32, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg])), matchValue[0] ? (matchValue[1] * 1) : undefined);
};

function Decode_natMeasure() {
    return (arg) => {
        const clo_1 = uint32(arg);
        return clo_1;
    };
}

export function Decode_set(decoder) {
    return (path_1) => ((value_1) => map_1((array) => ofArray(array, {
        Compare: compare,
    }), (path, value) => array_1(decoder, path, value), path_1, value_1));
}

function Decode_wrapKeys(mapping, keyWrap, decodeValue) {
    let d;
    let value_1;
    const decoder = decodeValue;
    value_1 = ((path) => ((value) => keyValuePairs(decoder, path, value)));
    d = ((arg) => {
        const clo_1 = value_1(arg);
        return clo_1;
    });
    return (path_1) => ((value_2) => map_1(mapping, uncurry2(d), path_1, value_2));
}

function Decode_parseKeysWith(mapping, parseKey, decodeValue) {
    return (path_2) => ((value_3) => andThen(uncurry3((kvps) => {
        const acc = [];
        const parseKeys = (_arg_mut) => {
            parseKeys:
            while (true) {
                const _arg = _arg_mut;
                if (!isEmpty(_arg)) {
                    const matchValue = parseKey(head(_arg)[0]);
                    if (matchValue == null) {
                        return false;
                    }
                    else {
                        const key_1 = value_8(matchValue);
                        void (acc.push([key_1, head(_arg)[1]]));
                        _arg_mut = tail(_arg);
                        continue parseKeys;
                    }
                }
                else {
                    return true;
                }
                break;
            }
        };
        if (parseKeys(kvps)) {
            const output = mapping(acc);
            return (arg10$0040) => ((arg20$0040) => succeed(output, arg10$0040, arg20$0040));
        }
        else {
            return (path_1) => ((value_2) => (new FSharpResult$2(1, [[path_1, new ErrorReason(0, ["a valid key", value_2])]])));
        }
    }), (path, value) => keyValuePairs(decodeValue, path, value), path_2, value_3));
}

export function Decode_table(keyWrap, decodeValue) {
    return Decode_wrapKeys((seq) => (new Table$2(Table_addAll(new Dictionary([], {
        Equals: equals,
        GetHashCode: structuralHash,
    }), seq))), keyWrap, decodeValue);
}

export function Decode_tableParse(parseKey, decodeValue) {
    return Decode_parseKeysWith((seq) => (new Table$2(Table_addAll(new Dictionary([], {
        Equals: equals,
        GetHashCode: structuralHash,
    }), seq))), parseKey, decodeValue);
}

export const Decode_fertilizer = (() => {
    const u = defaultOf();
    return (path_2) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Fertilizer((objectArg = get$.Required, objectArg.Field("Name", string)), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("Quality", uncurry2(uint32))), 0), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("Speed", float)), 0));
    }, path_2, v));
})();

export const Decode_itemId = Decode_natMeasure();

export const Decode_seedId = Decode_natMeasure();

export const Decode_season = (path_2) => ((value_1) => andThen(uncurry3((str) => {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParseEnum(enum_type("StardewValleyStonks.Season", int32_type, [["Spring", 0], ["Summer", 1], ["Fall", 2], ["Winter", 3]]), str, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    if (matchValue[0]) {
        return (arg10$0040) => ((arg20$0040) => succeed(matchValue[1], arg10$0040, arg20$0040));
    }
    else {
        return (path_1) => ((arg20$0040_1) => fail(`Failed to parse season: ${str}`, path_1, arg20$0040_1));
    }
}), string, path_2, value_1));

export const Decode_seasons = (path_1) => ((value_1) => map_1(SeasonsModule_ofSeq, (path, value) => array_1(uncurry2(Decode_season), path, value), path_1, value_1));

export const Decode_date = (() => {
    const u = defaultOf();
    return (path) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Date$((objectArg = get$.Required, objectArg.Field("Season", uncurry2(Decode_season))), (objectArg_1 = get$.Required, objectArg_1.Field("Day", uncurry2(uint32))));
    }, path, v));
})();

export const Decode_seedPrice = (path_7) => ((value_7) => andThen(uncurry3((tupledArg) => ((path_6) => {
    const kind = tupledArg[0];
    const vendor = tupledArg[1];
    const price = tupledArg[2];
    return (value_6) => ((kind === "Fixed") ? ((price == null) ? (new FSharpResult$2(1, [[path_6, new ErrorReason(3, [`an object with a field named '${"Price"}'`, value_6])]])) : (new FSharpResult$2(0, [new SeedPrice(0, [vendor, price])]))) : ((kind === "Scaling") ? ((price == null) ? (new FSharpResult$2(0, [new SeedPrice(1, [vendor, undefined])])) : (new FSharpResult$2(0, [new SeedPrice(1, [vendor, price])]))) : (new FSharpResult$2(1, [[path_6, new ErrorReason(0, [`a valid price type ('${"Fixed"}' or '${"Scaling"}')`, value_6])]]))));
})), (path_5, value_5) => map3((a, b, c) => [a, b, c], (path_1, value_1) => field_1("Type", string, path_1, value_1), (path_3, value_3) => field_1("Vendor", string, path_3, value_3), (path_4, value_4) => optional("Price", uncurry2(uint32), path_4, value_4), path_5, value_5), path_7, value_7));

export const Decode_cropAmount = (() => {
    const u = defaultOf();
    return (path_3) => ((v) => object_1((get$) => {
        const field = (name, decoder, defaultValue) => {
            let objectArg;
            return defaultArg((objectArg = get$.Optional, objectArg.Field(name, uncurry2(decoder))), defaultValue);
        };
        const MinCropYield = field("MinCropYield", uint32, CropAmountModule_singleAmount.MinCropYield);
        const MaxCropYield = field("MaxCropYield", uint32, CropAmountModule_singleAmount.MaxCropYield);
        const FarmLevelsPerYieldIncrease = field("FarmLevelsPerYieldIncrease", uint32, CropAmountModule_singleAmount.FarmLevelsPerYieldIncrease);
        return new CropAmount(MinCropYield, MaxCropYield, field("ExtraCropChance", (path) => ((value) => float(path, value)), CropAmountModule_singleAmount.ExtraCropChance), field("CanDouble", (path_1) => ((value_1) => bool(path_1, value_1)), CropAmountModule_singleAmount.CanDouble), FarmLevelsPerYieldIncrease, field("FarmingQualities", (path_2) => ((value_2) => bool(path_2, value_2)), CropAmountModule_singleAmount.FarmingQualities));
    }, path_3, v));
})();

export const Decode_farmCrop = (() => {
    const u = defaultOf();
    return (path_4) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, arg_7, objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8;
        return new FarmCrop((objectArg = get$.Required, objectArg.Field("Seed", uncurry2(Decode_seedId))), (objectArg_1 = get$.Required, objectArg_1.Field("Item", uncurry2(Decode_itemId))), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("Amount", uncurry2(Decode_cropAmount))), CropAmountModule_singleAmount), (arg_7 = tuple2_1(uncurry2(Decode_itemId), float), (objectArg_3 = get$.Optional, objectArg_3.Field("ExtraItem", uncurry2(arg_7)))), defaultArg((objectArg_4 = get$.Optional, objectArg_4.Field("Giant", bool)), false), (objectArg_5 = get$.Required, objectArg_5.Field("Seasons", uncurry2(Decode_seasons))), (objectArg_6 = get$.Required, objectArg_6.Field("Stages", (path_2, value_3) => array_1(uncurry2(uint32), path_2, value_3))), (objectArg_7 = get$.Optional, objectArg_7.Field("RegrowTime", uncurry2(uint32))), defaultArg((objectArg_8 = get$.Optional, objectArg_8.Field("Paddy", bool)), false));
    }, path_4, v));
})();

export const Decode_forageCrop = (() => {
    const u = defaultOf();
    return (path_2) => ((v) => object_1((get$) => {
        const field = (name, decoder) => {
            const objectArg = get$.Required;
            return objectArg.Field(name, uncurry2(decoder));
        };
        return new ForageCrop(field("Seed", Decode_seedId), field("Foragables", (path) => ((value) => array_1(uncurry2(Decode_itemId), path, value))), field("SeedRecipeUnlockLevel", uint32), field("Season", Decode_season), field("Stages", (path_1) => ((value_1) => array_1(uncurry2(uint32), path_1, value_1))));
    }, path_2, v));
})();

export const Decode_extractedData = (() => {
    const u = defaultOf();
    return (path_2) => ((v) => object_1((get$) => {
        const field = (name, decode) => {
            const objectArg = get$.Required;
            return objectArg.Field(name, uncurry2(decode));
        };
        return new ExtractedData(field("Items", Auto_generateBoxedDecoder_Z6670B51(array_type(Item_$reflection()), undefined, undefined)), field("Products", Decode_tableParse(Decode_parseItemId, uncurry2(Auto_generateBoxedDecoder_Z6670B51(array_type(ProcessedItem_$reflection()), undefined, undefined)))), field("FarmCrops", (path) => ((value) => array_1(uncurry2(Decode_farmCrop), path, value))), field("ForageCrops", (path_1) => ((value_1) => array_1(uncurry2(Decode_forageCrop), path_1, value_1))));
    }, path_2, v));
})();

export const Decode_supplementalData = (() => {
    const u = defaultOf();
    return (path_3) => ((v) => object_1((get$) => {
        const field = (name, decode) => {
            const objectArg = get$.Required;
            return objectArg.Field(name, uncurry2(decode));
        };
        return new SupplementalData(field("Fertilizers", (path) => ((value) => array_1(uncurry2(Decode_fertilizer), path, value))), field("FertilizerPrices", Decode_table((x) => x, uncurry2(Decode_table((x_1) => x_1, uncurry2(uint32))))), field("GenerateSeedPrices", Decode_table((x_2) => x_2, (path_1, value_1) => array_1(uncurry2(Decode_seedId), path_1, value_1))), field("SeedPrices", Decode_tableParse(Decode_parseSeedId, (path_2, value_2) => array_1(uncurry2(Decode_seedPrice), path_2, value_2))), field("ProcessorUnlockLevel", Decode_table((x_3) => x_3, uncurry2(uint32))));
    }, path_3, v));
})();

//# sourceMappingURL=Data.js.map
